/** Short, cancellable batches for cold display work that still needs DOM fonts.
 * Exact export and pixel picking never use this queue. */
export class DisplayWork {
  private jobs = new Map<object, () => void>();
  private timer: ReturnType<typeof setTimeout> | undefined;
  private longest = 0;
  enqueue(key: object, work: () => void) {
    this.jobs.set(key, work);
    this.schedule();
  }
  cancel(key: object) {
    this.jobs.delete(key);
  }
  private schedule() {
    if (this.timer !== undefined || !this.jobs.size) return;
    this.timer = setTimeout(() => {
      this.timer = undefined;
      const start = performance.now();
      try {
        while (this.jobs.size && performance.now() - start < 4) {
          const [key, job] = this.jobs.entries().next().value!;
          this.jobs.delete(key);
          job();
        }
      } finally {
        this.longest = Math.max(this.longest, performance.now() - start);
        this.schedule();
      }
    }, 0);
  }
  reset() {
    clearTimeout(this.timer);
    this.timer = undefined;
    this.jobs.clear();
  }
  stats() {
    return { pending: this.jobs.size, longestBatchMs: this.longest };
  }
}
